import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './styles.css';
import { getCRMBaseUrl, getUserCurrentOrganization } from '../../../../Auth/AuthReducer'
import { getContactUrl } from '../../../../../util/crm-url';

class ContactDetailRenderer extends Component {
  renderValue() {
    const { value, data, crmBaseUrl, idField, organization } = this.props;
    const { title, phone } = data;
    const phoneExt = data.phone_ext;
    const mobilePhone = data.mobile_phone;
    const rows = [];
    if (title) {
      rows.push({ label: 'Title', value: title });
    }
    if (phone) {
      let phoneStr = phone;
      if (phoneExt) {
        phoneStr += ` ext. ${phoneStr}`;
      }
      rows.push({ label: 'Phone', value: phoneStr });
    }
    if (mobilePhone) {
      rows.push({ label: 'Mobile', value: mobilePhone });
    }

    const popover = (
      <Tooltip className={styles.popover} id={`survey-contact-${data._id}`}>
        <div className="text-left">
          <div><strong>{value}</strong></div>
          <table className="table table-condensed" style={{ margin: 0 }}>
            <tbody>
              {rows.map((row) => {
                return (
                  <tr key={row.label}>
                    <td>{row.label}</td>
                    <td>{row.value}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Tooltip>
    );
    let comp = (<span className={styles.popoverTrigger}>{value}</span>);
    if (crmBaseUrl && idField && data[idField]) {
      const url = getContactUrl(organization, { contact_id: data[idField] });
      comp = url ? (
        <a target="_blank" href={url} rel="noreferrer">
          {comp}
        </a>
      ) : comp;
    }

    return (
      <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
        {comp}
      </OverlayTrigger>
    );
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderValue();
    }
    return null;
  }
}

ContactDetailRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    phone: PropTypes.string,
    phone_ext: PropTypes.string,
    mobile_phone: PropTypes.string,
  }),
  organization: PropTypes.shape({
    type: PropTypes.string,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  crmBaseUrl: PropTypes.string,
  idField: PropTypes.string,
};
ContactDetailRenderer.defaultProps = {
  value: null,
  data: null,
  node: null,
  crmBaseUrl: null,
  idField: null,
};

function mapStateToProps(state) {
  return {
    crmBaseUrl: getCRMBaseUrl(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(ContactDetailRenderer);
